import { useRef, useState } from "react";
import { CustomSearchBar } from "../../CustomSearchBar";
import { makeStyles } from "@mui/styles";
import { IconButton } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";
import { useServices } from "../../../hooks/encuestas/useServices";

export const SectionServices = (props) => {

    const { label, data, setValue, disabled } = props;
    const { services } = useServices();
    const [filterServices, setFilterServices] = useState([]);
    const [servicesSelected, setServicesSelected] = useState(data || []);

    const dragService = useRef(0);
    const draggedOverService = useRef(0);

    const styles = useStyles();

    const searchQuestions = (value) => {
        if(value.length <= 0 || disabled)
            return setFilterServices([]);

        //Filtra los valores que coinciden con la busqueda
        const search = services.filter(q => q?.servicio.toLowerCase().includes(value.toLowerCase()) && q?.activo !== false);

        //Retorna las preguntas que no han sido seleccionadas y ordena y limpia el array de los valores en blanco
        const result = search?.map(q => servicesSelected?.every(s => q?.servicio !== s?.servicio) ? q : '')?.filter(i => i?.servicio).sort((a,b) => {
            if (a.servicio > b.servicio) return 1;
            if (a.servicio < b.servicio) return -1;
            
            return 0;
        });

        setFilterServices(result);
    }

    const selectedServices = (e) => {
        if(disabled) return;
        setFilterServices(filterServices?.filter(f => f?._id !== e?._id));
        setServicesSelected(prev => {
            setValue("servicios", [...prev?.map(p => p?._id), e?._id]);
            return ([ ...prev, e ])
        });
    }

    const deleteServiceSelected = (e) => {
        if(disabled) return;
        const filters = servicesSelected?.filter(f => f?._id !== e?._id);
        setServicesSelected(filters);
        setValue("servicios", filters.map(f => f?._id));

        const response = filterServices.some(f => f?.servicio.charAt(0) === e?.servicio.charAt(0));
        response && setFilterServices(prev => ([ ...prev, e ]));
    }

    const handleServicesSelectedSort = () => {
        const servicesSelectedClone = [ ...servicesSelected ];
        const temp = servicesSelectedClone[dragService.current];
        servicesSelectedClone[dragService.current] = servicesSelectedClone[draggedOverService.current];
        servicesSelectedClone[draggedOverService.current] = temp;
        setServicesSelected(servicesSelectedClone);

        setServicesSelected(() => {
            setValue("servicios", [...servicesSelectedClone?.map(p => p?._id)]);
            return servicesSelectedClone
        });
    }   

    return (
        <div style={{ display: 'flex', flexFlow: 'column noWrap', gap: 5, marginBottom: 15 }}>
           { !disabled && (
                <>
                    <label style={{ fontWeight: 600, fontSize: 14 }} htmlFor="input">{ label }</label>
                    <div style={{ marginBottom: 15 }}>
                        <CustomSearchBar
                            action={ searchQuestions} 
                            placeholder='Servicio' 
                            disabled={ disabled }
                        />
                
                        <div style={{ display: filterServices?.length <= 0 ? 'none' : 'block', width: '100%', minHeight: 0, maxHeight: 100, overflowY: 'scroll', background: '#f5f5f5', borderTop: 0, borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                            { filterServices.map(q => <ListItemService key={ q?._id } action={ selectedServices } service={ q }/>) }
                        </div> 
                    </div>
                </>
            )}
            
            <>
                <label style={{ fontWeight: 600, fontSize: 14 }}>Servicios seleccionados</label>
                {
                    servicesSelected?.length <= 0 ? (
                        <div className={ styles.bodyServicesSelected }>
                            <span style={{ fontSize: 13, color: 'grey' }}>Vacio</span>
                        </div>
                    ) : (  
                        <>
                            <div style={{ border: '1px solid #bdbdbd', background: '#fff', minHeight: 100, maxHeight: 150, borderRadius: 4, overflowY: 'scroll' }}>
                                { servicesSelected?.map((s, i) => (
                                    <ListItemServiceSelected 
                                        index={ i } 
                                        key={ s?._id } 
                                        action={ () => deleteServiceSelected(s) } 
                                        service={ s } 
                                        disabled={ disabled }
                                        dragService={ dragService }
                                        draggedOverService={ draggedOverService }
                                        onDragEnd={ handleServicesSelectedSort }
                                    />
                                )) }
                            </div> 
                            <span style={{ fontSize: 13, color: 'grey', fontWeight: 500 }}>Total: { servicesSelected?.length }</span>
                        </>
                    )
                }
            </>
        </div>
    )
}

SectionServices.defaultProps = {
    label: '',
    data: [],
    setValue: () => false,
    disabled: false
}

const ListItemService = (props) => {

    const { action, service } = props;
    const styles = useStyles();

    return (
        <div className={ styles.listService } onClick={ () => action(service) }>
            <span style={{ fontWeight: 500, fontSize: 12 }}>{ service?.servicio.length > 50 ? convertirLetraMayus(service?.servicio?.substring(0, 50) + '...') : convertirLetraMayus(service?.servicio) }</span>
        </div>
    )
}

ListItemService.defaultProps = {
    action: () => false,
    service: {}
}


const ListItemServiceSelected = (props) => {

    const { index, action, service, disabled, dragService, draggedOverService, onDragEnd } = props;
    const styles = useStyles();

    return (
        <div 
            className={ disabled ? styles.listServiceSelectedDisabled : styles.listServiceSelected }
            draggable
            onDragStart={ () => dragService.current = index }
            onDragEnter={ () => draggedOverService.current = index }
            onDragEnd={ onDragEnd }
            onDragOver={ (e) => e.preventDefault() }
        >
            <span style={{ fontWeight: 500, fontSize: 12, marginLeft: 10 }}>{ service?.servicio.length > 50 ? convertirLetraMayus(service?.servicio?.substring(0, 45) + '...') : convertirLetraMayus(service?.servicio) }</span>
            <IconButton onClick={ action } disabled={ disabled }>
                <CloseOutlined htmlColor={ disabled ? 'B8B8B8' : '#00365F' } style={{ fontSize: 13 }} />
            </IconButton>
        </div>
    )
}

ListItemServiceSelected.defaultProps = {
    action: () => false,
    service: {},
    disabled: false
}

const useStyles = makeStyles({
    listService: {
        padding: '1px 10px', 
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fff',
        border: '1px solid #E0E0E0', 
        margin: 5, 
        borderRadius: 4,
        '&:hover': {
            background: '#00365F !important',
            color: '#fff !important',
            fontWeight: 'bold !important',
            cursor: 'pointer'
        },
        '&:active' : {
            color: '#00365F !important',
            background: '#fff !important',
            borderColor: '#00365F !important',
            cursor: 'pointer'
        }
    },

    listServiceSelected: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#fff',
        color: '#00365F',
        border: '1.5px solid #00365F', 
        margin: 5,
        borderRadius: 4,
        cursor: 'pointer'
    },

    listServiceSelectedDisabled: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#fff',
        color: '#B8B8B8',
        border: '1.5px solid #B8B8B8', 
        margin: 5,
        borderRadius: 4,
    },

    bodyServicesSelected : {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        border: '1px solid #bdbdbd', 
        background: '#fff', 
        minHeight: 100, 
        maxHeight: 150, 
        borderRadius: 4, 
        overflowY: 'scroll'
    }
});